import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  rewardLogsControllerCreate,
  RewardLogsControllerCreate$Params,
  rewardLogsControllerDelete,
  rewardLogsControllerFindAll,
  RewardLogsControllerFindAll$Params,
} from '@klubovna/api-client';
import { CreateRewardLogDto, RewardLog } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface RewardLogsQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  userId?: string;
  rewardId?: string;
  sortBy?: 'createdAt' | 'updatedAt' | 'spentPoints' | 'rewardName' | 'volunteerName';
  sortOrder?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class RewardLogsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: RewardLogsQueryParams): Observable<PaginatedResponse<RewardLog>> {
    const apiParams: RewardLogsControllerFindAll$Params = {
      page: params?.page,
      limit: params?.limit,
      search: params?.search,
      userId: params?.userId,
      rewardId: params?.rewardId,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
    };

    return rewardLogsControllerFindAll(this.http, this.apiConfig.rootUrl, apiParams)
      .pipe(map(response => toPaginatedResponse<RewardLog>(response.body)));
  }

  create(rewardLogData: CreateRewardLogDto): Observable<RewardLog> {
    const params: RewardLogsControllerCreate$Params = {
      body: rewardLogData,
    };
    return rewardLogsControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as RewardLog));
  }

  delete(id: string): Observable<void> {
    return rewardLogsControllerDelete(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(() => undefined));
  }
}

